import type { CinematicSequence } from '../../../../renderer/src/cinematic-sequence';
import { cinematicAnchorAt, cinematicTimeline } from '../../domain/cinematic-timeline';
import { sceneFrameProgress } from '../scene-keyframes';
import type { RidePoint } from '../../domain/ride';

export function moveTimelineWaypoint(points: readonly RidePoint[], sequence: CinematicSequence, id: string, seconds: number, duration: number) {
  if (!Number.isFinite(seconds) || !sequence.waypoints.some(item => item.id === id)) {
    throw new Error('Choose an existing keyframe and a valid film time.');
  }
  const filmProgress = sceneFrameProgress(seconds / duration, duration);
  const anchor = cinematicAnchorAt(points, filmProgress, duration);
  if (cinematicTimeline(points, sequence, duration).some(item => item.waypoint.id !== id
    && Math.round(item.seconds / duration * (duration * 30 - 1)) === Math.round(filmProgress * (duration * 30 - 1)))) {
    throw new Error('A keyframe already occupies that position. Choose another time.');
  }
  const moved = { ...sequence, waypoints: sequence.waypoints.map(item => item.id === id ? { ...item, anchor, filmProgress } : item) };
  const timeline = cinematicTimeline(points, moved, duration);
  return { sequence: { ...moved, waypoints: timeline.map(item => item.waypoint) }, progress: timeline.find(item => item.waypoint.id === id)!.seconds / duration };
}
